module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_trademarks_2.c9b7c47e.png";